module.exports = __webpack_public_path__ + "media/bootstrap-icons/forward-97d40d13.svg";